import {createSlice} from "@reduxjs/toolkit";
import {fillInput} from "../functions";
import _axios from "../../../httpService";
import {toast} from "react-toastify";
import {prefixUrl} from "../../../utils/utilsData";
import tableCalc from "../../../utils/tableCalc";
import {DownArrowBorder} from "../../../Assets/svg";
import {useSelector} from "react-redux";

const initialSendData = {
  showLoadingInTable: false,
  isOverall: false, // show which table show? details or  table with button
  mode: 'overall',
  dowDataClicked: {},
  showHandlers: false, // show or don't show handlers
  handlerButton: {
    group: true, kol: false, moein: false, tafsili: false,
  },


  isItFirstTimeToRequestLink:true, // آیا این دفعه اوله داره روی زنجیر میزنه؟ برای اون  مسیر لازمه
  path: [], // برای نمایش زنجیر ها نیازه و جایی که  میخواد کلیک کنه بره قبلی
  passedAccounts: [],
  selectedRow: undefined, // وقتی کاربر توی جدول روی یه سطر کلیک میزنه
  // زمانی کاربرد داره که روی مسیر بالای جدول کلیک میکنیم و میخوایم دوباره اون سطر در حالت انتخاب بره
  // selectedLevel: 0,
  selectedRowCode: 0, prevLevel: "", // آخرین لولی که توی جدول روش کلیک کرده با کد اینجا نگه داشته میشه
  myData: {
    column: [],
    data: [],
    priceFields: [],
    currentLevel: 0,
    mainCurrentLevel: 0,
    level_1: [],
    level_2: [],
    level_3: [],
    path: [],
  },
  filterValues: {
    "type": "all", "year": "", "month": "", "startDate": "", "endDate": "", "firstId": "", "lastId": "",
  }
}

const reviewAccountsReducers = {
  fillInput, fillInitialData: (state, action) => {
    state.initialData = action.payload.initialData
  },

  // timePeriodChanger: (state, action) => {
  //   state.timePeriod = action.payload.timePeriod
  // }

}


export const reviewAccountSlice = createSlice({
  name: 'reviewAccountsReducers', initialState: initialSendData, reducers: reviewAccountsReducers
});


export const requestTableDataReview = (
  {
    level = 0,
    prevLevel = '',
    accountCode = "",
    mode = 'overall',
    passedLevels = [],
    passedAccounts = [],
    downToUpType = 0,
    path = [],
    filters
  }
) => {


  const dddd = {
    accountCode,
    prevLevel,
    level,
    mode,
    passedAccounts,
    passedLevels,
  }
  localStorage.setItem("lastRequestPayload", JSON.stringify(dddd))

  path = JSON.stringify(path)
  passedLevels = JSON.stringify(passedLevels)
  passedAccounts = JSON.stringify(passedAccounts)

  return async (dispatch) => {


    const url = prefixUrl() + "/accountingTreeChart/" + `?request=accountTransactions&prevLevel=${prevLevel}&level=${level}&accountCode=${accountCode}&mode=${mode}&downToUpType=${downToUpType}&passedLevels=${passedLevels}&passedAccounts=${passedAccounts}&path=${path}&filter=${filters}`


    const run = async () => {
      try {
        //dispatch(reviewAccountAction.fillInput({showLoadingInTable: true}))
        const response = await _axios.get(url);

        if (response.data.status) {
          const myData = Object.assign({}, response.data.data)
          myData.data = myData.data.map(v => {
            v.currentLevel = response.data.data.currentLevel
            v.mainCurrentLevel = response.data.data.mainCurrentLevel
            return v;
          })


          const column = myData.column;

          const isOverAll = response.data.data.isOverall;
          column.forEach(v => {
            if (response.data?.data?.priceFields.includes(v.field)) v.bottomCalc = "sum"
          })
          if (isOverAll) {
            column.forEach(v => {
              v.style = {
                display: 'flex', justifyContent: 'center', alignItem: 'center'
              }

            })

          } else {
            // column.forEach(v => {
            //   v.style = {
            //     display: 'flex',
            //     justifyContent: 'center',
            //     alignItem: 'center'
            //   }
            // })
          }

          if (response.data?.data?.priceFields?.length > 0) {
            const priceFields = [...response.data?.data?.priceFields]
            tableCalc.addSeparator(column, priceFields)
          }
          dispatch(reviewAccountAction.fillInput({
            myData: myData, showLoadingInTable: false, showHandlers: false,
            passedAccounts: myData.passedAccounts,
          }))


        } else {
          // dispatch(fillInput({receivedData: response.data.data}))
          toast.error(response?.data?.message)
        }
      } catch (error) {
        console.log(error)
      }
    }

    const result = run()
    await toast.promise(result, {
      pending: "در حال دریافت اطلاعات", // success: "اطلاعات دریافت شد.",
      //error: "",
    });
  }
}

export const reviewAccountAction = reviewAccountSlice.actions
export default reviewAccountSlice.reducer